var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(71,145,255,0.15);}.b{fill:none;}.c{fill:#4791ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-485.5 -980.862)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    rx: 1,
    transform: "translate(485.5 980.862)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485.5 980.862)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H18V18H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.032,12.625V8.875a4.57,4.57,0,0,0-3.375-4.74v-.51A1.13,1.13,0,0,0,9.525,2.5,1.117,1.117,0,0,0,8.407,3.625v.51a4.556,4.556,0,0,0-3.375,4.74v3.75l-.975.968a.75.75,0,0,0,.525,1.282H14.46a.752.752,0,0,0,.532-1.282Zm-4.508,4.5a1.5,1.5,0,0,0,1.5-1.5h-3A1.5,1.5,0,0,0,9.525,17.125ZM5.61,4.173A.739.739,0,0,0,5.632,3.1.75.75,0,0,0,4.59,3.085,7.818,7.818,0,0,0,2.137,7.63a.758.758,0,0,0,.75.87.748.748,0,0,0,.735-.622A6.33,6.33,0,0,1,5.61,4.173Zm8.873-1.088a.759.759,0,0,0-1.05.015.736.736,0,0,0,.023,1.065A6.372,6.372,0,0,1,15.442,7.87a.736.736,0,0,0,.735.622.753.753,0,0,0,.743-.87,7.866,7.866,0,0,0-2.438-4.538Z",
    transform: "translate(-0.532 -0.625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconBlue);
export default __webpack_public_path__ + "static/media/alertIcon_blue.d7c75e842c47c78a96f2375dee14d4d7.svg";
export { ForwardRef as ReactComponent };